import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { MdEmail, MdFamilyRestroom } from 'react-icons/md';
import { format } from 'date-fns';
import baseURL from '../../config/api';
import { BsFillTelephoneFill, BsSearch } from 'react-icons/bs';
import { RiArrowDownSFill } from 'react-icons/ri';
import { RxCross1 } from 'react-icons/rx';
import Pagination from '../../components/Pagination';
import { formatUSPhone } from '../../utils/phoneFormatter';
import useGroup from '../../hook/useGroup';
import useSubGroup from '../../hook/useSubGroup';
import { SubGroupSelect } from '../../components/SubGroupSelect';
import { formatDateForDisplay } from '../../utils/getUserDateFormat';
import Cookies from 'js-cookie';
import PdfDirectoryExport from '../../components/PdfDirectoryExport';
import SendSms from '../../components/SendSms';
import SendEmail from '../../components/SendEmail';
import { isPremiumPlan } from '../../utils/isPremiumPlan';
import ImportView from './ImportView';
import { fetchAllFamilyMembersForExport } from '../../services/FamilyMember';
import useAuth from '../../hook/useAuth';

const FamilyMembers = () => {
    const token = Cookies.get("token-my-cdir");
    const plan = Cookies.get("plan-my-cdir") || "";
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const { selectedGroupId, isSuperAdmin }: any = useGroup();
    const { selectedSubGroupId }: any = useSubGroup();
    const location = useLocation();
    const pathRoot = isSuperAdmin ? "superadmin" : "admin";
    const [searchValue, setSearchValue] = useState<string>("");
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [displayFilter, setDisplayFilter] = useState<boolean>(false);
    const [memberFilterValue, setMemberFilterValue] = useState(0);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [paginationModel, setPaginationModel] = useState<{ page: number, size: number }>({
        page: 0,
        size: 10,
    });
    const [totalLength, setTotalLength] = useState<number>(0);
    const [selectedFilter, setSelectedFilter] = useState<string>("Member Name");
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [showEntries, setShowEntries] = useState<number>(10);
    const [expandedMembers, setExpandedMembers] = useState<any>({});

    const [showTheSmsPopup, setShowTheSmsPopup] = useState<boolean>(false);
    const [showTheEmailPopup, setShowTheEmailPopup] = useState<boolean>(false);

    useEffect(() => {
        if (!isFirstTime) {
            setSelectedFilter("Member Name");
            setMemberFilterValue(0);
            if (searchValue !== "") {
                setSearchValue("");
                setIsFirstTime(false);
            }
            else {
                setPaginationModel({
                    page: 0,
                    size: 10
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGroupId])

    useEffect(() => {
        if (!isFirstTime) {
            setPaginationModel({
                page: 0,
                size: 10
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedSubGroupId])

    useEffect(() => {
        if (searchValue === "" && !isFirstTime) {
            const newPaginationModel = {
                page: 0,
                size: paginationModel.size,
            };

            setPaginationModel(newPaginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue === "") {
            setIsFirstTime(false)
            apiCall(paginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const apiCall = (newPaginationModel: { page: number, size: number }) => {
        if (selectedGroupId > 0 && selectedSubGroupId > 0) {
            setIsDataLoaded(true);
            fetch(`${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdAndSubGroupIdPaging/${selectedSubGroupId},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`, {
                headers: {
                    Authorization: `Bearer ${token?.toString()}`
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    const result = data.familyMemberReport.map((item: any) => {
                        return {
                            ...item,
                            name: item.firstName + " " + item.lastName,
                            filePath:
                                item?.filePath ? `${baseURL}commonFile/Get?name=${item.filePath}` :
                                    "./images/user-default.jpg",
                            birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                            address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                            subGroups: item?.familyMemberSubGroupReportDto?.map(
                                (sg: any) => sg.subGroupName
                            ) || []
                        };
                    })

                    setSearchTableData(result);
                    setTotalLength(data.count);
                    setIsDataLoaded(false);

                }).catch((error) => {
                    console.log(error);
                    setIsDataLoaded(false);
                    setSearchTableData([]);
                    setTotalLength(0);
                });
        }
        else if (selectedGroupId > 0 && selectedSubGroupId === 0) {
            setIsDataLoaded(true);
            fetch(`${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdPaging/${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`, {
                headers: {
                    Authorization: `Bearer ${token?.toString()}`
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    const result = data.familyMemberReport.map((item: any) => {
                        return {
                            ...item,
                            name: item.firstName + " " + item.lastName,
                            filePath:
                                item?.filePath ? `${baseURL}commonFile/Get?name=${item.filePath}` :
                                    "./images/user-default.jpg",
                            birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                            address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                            subGroups: item?.familyMemberSubGroupReportDto?.map(
                                (sg: any) => sg.subGroupName
                            ) || []
                        };
                    })

                    setSearchTableData(result);
                    setTotalLength(data.count);
                    setIsDataLoaded(false);

                }).catch((error) => {
                    console.log(error);
                    setIsDataLoaded(false);
                    setSearchTableData([]);
                    setTotalLength(0);
                });
        }
        else {
            setIsDataLoaded(false);
            setSearchTableData([]);
            setTotalLength(0);
        }
    }

    useEffect(() => {
        if (location.state?.refresh) {
            apiCall(paginationModel);
            navigate(location.pathname, { replace: true, state: {} });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.state]);

    useEffect(() => {
        let timeOutId: NodeJS.Timeout;

        if (searchValue !== "") {
            timeOutId = setTimeout(() => {
                const newPaginationModel = {
                    page: 0,
                    size: paginationModel.size,
                };

                setPaginationModel(newPaginationModel);

            }, 1000);
        }

        return () => clearTimeout(timeOutId);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue !== "" && !isFirstTime) {
            filteApiCall(paginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const filteApiCall = (newPaginationModel: { page: number, size: number }) => {
        let filterData: any[] = [];
        setIsDataLoaded(true);
        if (selectedGroupId > 0 && selectedSubGroupId > 0) {
            switch (memberFilterValue) {
                case 0:
                    fetch(
                        `${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdAndSubGroupIdAndSearchWithMemberName/${searchValue},${selectedSubGroupId},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token?.toString()}`
                            }
                        }
                    )
                        .then((res) => res.json())
                        .then((data) => {
                            filterData = data.familyMemberReport.map((item: any) => {
                                return {
                                    ...item,
                                    name: item.firstName + " " + item.lastName,
                                    filePath:
                                        item?.filePath ? `${baseURL}commonFile/Get?name=${item.filePath}` :
                                            "./images/user-default.jpg",
                                    birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                                    address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                                    subGroups: item?.familyMemberSubGroupReportDto?.map(
                                        (sg: any) => sg.subGroupName
                                    ) || []
                                };
                            })
                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setIsDataLoaded(false);

                        })
                        .catch((error) => {
                            console.log(error);
                            setIsDataLoaded(false);
                            setSearchTableData([]);
                            setTotalLength(0);
                        });

                    break;
                case 1:
                    fetch(
                        `${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdAndSubGroupIdAndSearchWithEmailAddress/${searchValue},${selectedSubGroupId},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token?.toString()}`
                            }
                        }
                    )
                        .then((res) => res.json())
                        .then((data) => {
                            filterData = data.familyMemberReport.map((item: any) => {
                                return {
                                    ...item,
                                    name: item.firstName + " " + item.lastName,
                                    filePath:
                                        item?.filePath ? `${baseURL}commonFile/Get?name=${item.filePath}` :
                                            "./images/user-default.jpg",
                                    birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                                    address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                                    subGroups: item?.familyMemberSubGroupReportDto?.map(
                                        (sg: any) => sg.subGroupName
                                    ) || []
                                };
                            })
                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setIsDataLoaded(false);

                        })
                        .catch((error) => {
                            console.log(error);
                            setIsDataLoaded(false);
                            setSearchTableData([]);
                            setTotalLength(0);
                        });

                    break;
                case 2:
                    fetch(
                        `${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdAndSubGroupIdAndSearchWithPhoneNumber/${searchValue},${selectedSubGroupId},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token?.toString()}`
                            }
                        }
                    )
                        .then((res) => res.json())
                        .then((data) => {
                            filterData = data.familyMemberReport.map((item: any) => {
                                return {
                                    ...item,
                                    name: item.firstName + " " + item.lastName,
                                    filePath:
                                        item?.filePath ? `${baseURL}commonFile/Get?name=${item.filePath}` :
                                            "./images/user-default.jpg",
                                    birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                                    address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                                    subGroups: item?.familyMemberSubGroupReportDto?.map(
                                        (sg: any) => sg.subGroupName
                                    ) || []
                                };
                            })
                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setIsDataLoaded(false);

                        })
                        .catch((error) => {
                            console.log(error);
                            setIsDataLoaded(false);
                            setSearchTableData([]);
                            setTotalLength(0);
                        });

                    break;

            }
        }
        else if (selectedGroupId > 0 && selectedSubGroupId === 0) {
            switch (memberFilterValue) {
                case 0:
                    fetch(
                        `${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdAndSearchWithMemberName/${searchValue},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token?.toString()}`
                            }
                        }
                    )
                        .then((res) => res.json())
                        .then((data) => {
                            filterData = data.familyMemberReport.map((item: any) => {
                                return {
                                    ...item,
                                    name: item.firstName + " " + item.lastName,
                                    filePath:
                                        item?.filePath ? `${baseURL}commonFile/Get?name=${item.filePath}` :
                                            "./images/user-default.jpg",
                                    birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                                    address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                                    subGroups: item?.familyMemberSubGroupReportDto?.map(
                                        (sg: any) => sg.subGroupName
                                    ) || []
                                };
                            })
                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setIsDataLoaded(false);

                        })
                        .catch((error) => {
                            console.log(error);
                            setIsDataLoaded(false);
                            setSearchTableData([]);
                            setTotalLength(0);
                        });

                    break;
                case 1:
                    fetch(
                        `${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdAndSearchWithEmailAddress/${searchValue},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token?.toString()}`
                            }
                        }
                    )
                        .then((res) => res.json())
                        .then((data) => {
                            filterData = data.familyMemberReport.map((item: any) => {
                                return {
                                    ...item,
                                    name: item.firstName + " " + item.lastName,
                                    filePath:
                                        item?.filePath ? `${baseURL}commonFile/Get?name=${item.filePath}` :
                                            "./images/user-default.jpg",
                                    birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                                    address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                                    subGroups: item?.familyMemberSubGroupReportDto?.map(
                                        (sg: any) => sg.subGroupName
                                    ) || []
                                };
                            })
                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setIsDataLoaded(false);

                        })
                        .catch((error) => {
                            console.log(error);
                            setIsDataLoaded(false);
                            setSearchTableData([]);
                            setTotalLength(0);
                        });

                    break;
                case 2:
                    fetch(
                        `${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdAndSearchWithPhoneNumber/${searchValue},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token?.toString()}`
                            }
                        }
                    )
                        .then((res) => res.json())
                        .then((data) => {
                            filterData = data.familyMemberReport.map((item: any) => {
                                return {
                                    ...item,
                                    name: item.firstName + " " + item.lastName,
                                    filePath:
                                        item?.filePath ? `${baseURL}commonFile/Get?name=${item.filePath}` :
                                            "./images/user-default.jpg",
                                    birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                                    address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                                    subGroups: item?.familyMemberSubGroupReportDto?.map(
                                        (sg: any) => sg.subGroupName
                                    ) || []
                                };
                            })
                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setIsDataLoaded(false);
                        })
                        .catch((error) => {
                            console.log(error);
                            setIsDataLoaded(false);
                            setSearchTableData([]);
                            setTotalLength(0);
                        });

                    break;
            }
        }
        else {
            setIsDataLoaded(false);
            setSearchTableData([]);
            setTotalLength(0);
        }
    }

    const applyFilter = () => {
        setSelectedFilter(() =>
            memberFilterValue === 0 ? "Member Name" : memberFilterValue === 1 ? "Email" : "Phone Number"
        );
        setSearchValue("");
        setDisplayFilter(false);
    };

    const clearFilter = () => {
        setSearchValue("");
        setDisplayFilter(false);
    };

    const toggleExpand = (id: number) => {
        setExpandedMembers((prev: any) => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const addFamilyMember = () => {
        navigate(`/${pathRoot}/members/addMember`);
    }

    const editFamilyMember = (id: string) => {
        navigate(`/${pathRoot}/members/editMember/${id}`);
    }

    const deleteFamilyMember = (id: string) => {
        navigate(`/${pathRoot}/members/deleteMember/${id}`);
    }

    const getExportApiUrl = () => {
        const page = 0;

        const size = totalLength || 1000;

        if (!searchValue) {
            if (selectedGroupId > 0 && selectedSubGroupId > 0) {
                return `${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdAndSubGroupIdPaging/${selectedSubGroupId},${selectedGroupId},${page},${size}`;
            }

            if (selectedGroupId > 0 && selectedSubGroupId === 0) {
                return `${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdPaging/${selectedGroupId},${page},${size}`;
            }

            return null;
        }

        const search = encodeURIComponent(searchValue);

        if (selectedGroupId > 0 && selectedSubGroupId > 0) {
            if (memberFilterValue === 0) {
                return `${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdAndSubGroupIdAndSearchWithMemberName/${search},${selectedSubGroupId},${selectedGroupId},${page},${size}`;
            }

            if (memberFilterValue === 1) {
                return `${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdAndSubGroupIdAndSearchWithEmailAddress/${search},${selectedSubGroupId},${selectedGroupId},${page},${size}`;
            }

            if (memberFilterValue === 2) {
                return `${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdAndSubGroupIdAndSearchWithPhoneNumber/${search},${selectedSubGroupId},${selectedGroupId},${page},${size}`;
            }
        }

        if (selectedGroupId > 0 && selectedSubGroupId === 0) {
            if (memberFilterValue === 0) {
                return `${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdAndSearchWithMemberName/${search},${selectedGroupId},${page},${size}`;
            }

            if (memberFilterValue === 1) {
                return `${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdAndSearchWithEmailAddress/${search},${selectedGroupId},${page},${size}`;
            }

            if (memberFilterValue === 2) {
                return `${baseURL}FamilyMember/GetFamilyMemberReportByGroupIdAndSearchWithPhoneNumber/${search},${selectedGroupId},${page},${size}`;
            }
        }

        return null;
    };

    const fetchMembersForExport = async () => {
        const exportUrl = getExportApiUrl();

        if (!exportUrl) {
            return [];
        }

        const response = await fetch(exportUrl, {
            headers: {
                Authorization: `Bearer ${token?.toString()}`,
            },
        });

        if (!response.ok) {
            throw new Error(
                "Unable to fetch members for export"
            );
        }

        const data = await response.json();

        return data?.familyMemberReport || [];
    };

    const mapMemberForExport = (item: any) => ({
        id: item.id,

        name: `${item?.firstName || ""} ${item?.lastName || ""
            }`.trim(),

        phone: item?.phoneNumber || "",

        email: item?.emailAddress || "",

        image: item?.filePath
            ? `${baseURL}commonFile/Get?name=${item.filePath}`
            : "/images/user-default.jpg",
    });

    return (
        <>
            <section className="user__container p-3 xm:p-4 overflow-x-hidden">
                {/* Header */}
                <div className="w-full flex flex-col xl:flex-row xl:items-center xl:justify-between gap-4">
                    <div className="flex items-center gap-2 shrink-0">
                        <MdFamilyRestroom
                            className="text-lg md:text-xl"
                        />

                        <h1 className="text-base md:text-lg font-medium">
                            Members
                        </h1>
                    </div>

                    <div className="w-full xl:w-auto flex flex-col sm:flex-row sm:flex-wrap xl:flex-nowrap items-stretch sm:items-center gap-2">
                        {
                            (isSuperAdmin || isPremiumPlan(plan)) && (
                                <>
                                    <button
                                        type="button"
                                        className="bg-secondary hover:bg-custom-blue px-4 py-2 rounded-sm text-white text-sm whitespace-nowrap w-full sm:w-auto"
                                        onClick={() => setShowTheSmsPopup(true)}
                                    >
                                        SMS To All Members
                                    </button>

                                    <button
                                        type="button"
                                        className="bg-secondary hover:bg-custom-blue px-4 py-2 rounded-sm text-white text-sm whitespace-nowrap w-full sm:w-auto"
                                        onClick={() => setShowTheEmailPopup(true)}
                                    >
                                        Email To All Members
                                    </button>
                                </>
                            )
                        }

                        <div className="flex flex-col xm:flex-row gap-2 md:gap-4 w-full xm:w-auto">
                            <ImportView importType="familyMembers" />

                            <PdfDirectoryExport
                                title="Members"
                                totalLength={totalLength}
                                fetchData={fetchMembersForExport}
                                exportType="familyMembers"
                                fetchExcelData={() =>
                                    fetchAllFamilyMembersForExport(
                                        selectedGroupId,
                                        auth?.id,
                                        auth?.givenname || "",
                                        token!
                                    )
                                }
                                mapItem={mapMemberForExport}
                            />

                            <button
                                type="button"
                                className="bg-secondary hover:bg-custom-blue px-4 py-2 rounded-sm text-white text-sm whitespace-nowrap w-full sm:w-auto"
                                onClick={addFamilyMember}
                            >
                                Add Member
                            </button>

                            <SubGroupSelect />
                        </div>
                    </div>
                </div>

                {/* FILTER + SEARCH */}
                <div className="flex flex-col xm:flex-row gap-3 justify-between xm:items-center border border-black p-2 mt-4">
                    <div className="relative flex flex-col xm:flex-row gap-3 items-start xm:items-center w-full">

                        <div className='relative w-full xm:w-auto'>
                            <button
                                className="bg-secondary text-white px-3 py-2 xm:py-1 rounded-md flex items-center justify-between w-full xm:w-auto whitespace-nowrap"
                                onClick={() => setDisplayFilter(!displayFilter)}
                            >
                                {selectedFilter}
                                <RiArrowDownSFill className="ml-1" />
                            </button>

                            <div
                                className={`${displayFilter ? "block" : "hidden"
                                    } absolute z-10 w-full xm:w-40 p-2 bg-white border border-black mt-2 xm:mt-0 xm:top-0 xm:left-full`}
                            >
                                <div className="flex justify-between">
                                    <label className="text-xs font-bold">Fields</label>
                                    <div
                                        onClick={() => setDisplayFilter(false)}
                                        className="w-4 h-4 cursor-pointer text-sm text-center"
                                    >
                                        <RxCross1 />
                                    </div>
                                </div>

                                <select
                                    className="w-full text-xs py-1 border mt-1"
                                    value={memberFilterValue}
                                    onChange={(e) =>
                                        setMemberFilterValue(parseInt(e.target.value))
                                    }
                                >
                                    <option value="0">Member Name</option>
                                    <option value="1">Email</option>
                                    <option value="2">Phone Number</option>
                                </select>

                                <div className='flex mt-2 justify-between'>
                                    <button
                                        className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full mr-1 whitespace-nowrap"
                                        onClick={() => applyFilter()}
                                    >
                                        Apply Filter
                                    </button>

                                    <button
                                        className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full ml-1"
                                        onClick={() => clearFilter()}
                                    >
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* SEARCH */}
                        <div className="flex items-center gap-2 w-full border px-2 py-1 rounded xm:border-none">
                            <div className="h-4 w-4 text-gray-900">
                                <BsSearch />
                            </div>

                            <input
                                type="text"
                                placeholder="Search…"
                                className="w-full text-sm xm:text-lg pl-2 outline-none"
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className="mt-4" />

                {!isDataLoaded ? (
                    <>
                        {searchTableData.length > 0 ? (
                            <div className="member__list__container grid grid-cols-1 3lg:grid-cols-2 gap-y-4 gap-x-4 m-auto w-full">
                                {searchTableData.slice(0, showEntries).map((item, index) => {

                                    const isExpanded = expandedMembers[item.id];

                                    const visibleSubGroups = isExpanded
                                        ? item?.subGroups || []
                                        : item?.subGroups?.slice(0, 3) || [];

                                    const remainingCount = (item?.subGroups?.length || 0) - 3;

                                    return (
                                        <div key={index} className="member__view__container flex flex-col xm:flex-row w-full h-fit gap-4 md:gap-8 bg-gray-50 shadow-2xl rounded-md p-3 xm:p-2">

                                            {/* LEFT */}
                                            <div className="member__view flex flex-col xm:flex-row gap-3 md:gap-4 w-full md:w-4/6">

                                                <img
                                                    src={item.filePath}
                                                    alt="member"
                                                    className="w-full xm:w-[150px] xm:h-[150px] object-cover object-top"
                                                    onError={({ currentTarget }) => {
                                                        currentTarget.onerror = null;
                                                        currentTarget.src = "/images/user-default.jpg";
                                                    }}
                                                />


                                                <div className="text__container flex flex-col flex-1 justify-between py-2 xm:py-4">
                                                    <div className="text-start">
                                                        <h1 className="name__text text-base xm:text-lg font-bold break-words">
                                                            {item.name}
                                                        </h1>
                                                        <h3 className="name__text text-xs xm:text-sm font-semibold">
                                                            {formatDateForDisplay(item.birthday)}
                                                        </h3>
                                                    </div>

                                                    <div className="mt-2">
                                                        <p className="text-xs font-semibold text-gray-500 mb-1">Ministries</p>

                                                        <div className="flex flex-wrap gap-1 items-center">
                                                            {visibleSubGroups.length > 0 ? (
                                                                <>
                                                                    {visibleSubGroups.map((sg: string, i: number) => (
                                                                        <span
                                                                            key={i}
                                                                            className="px-2 py-1 text-xs bg-blue-100 text-secondary rounded-full"
                                                                        >
                                                                            {sg}
                                                                        </span>
                                                                    ))}

                                                                    {!isExpanded && remainingCount > 0 && (
                                                                        <span
                                                                            onClick={() => toggleExpand(item.id)}
                                                                            className="px-2 py-1 text-xs bg-gray-200 text-gray-700 rounded-full cursor-pointer"
                                                                        >
                                                                            +{remainingCount} more
                                                                        </span>
                                                                    )}

                                                                    {isExpanded && (
                                                                        <span
                                                                            onClick={() => toggleExpand(item.id)}
                                                                            className="px-2 py-1 text-xs bg-gray-200 text-gray-700 rounded-full cursor-pointer"
                                                                        >
                                                                            Show less
                                                                        </span>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <span className="text-xs text-gray-400">No Ministries</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* RIGHT */}
                                            <div className="family__view flex flex-col-reverse xm:flex-col justify-between py-2 xm:py-4 min-w-[150px] w-full md:w-2/6">
                                                <div className="flex flex-col xm:flex-row gap-2">
                                                    <button
                                                        className="bg-secondary hover:bg-custom-blue px-4 py-2 rounded-sm font-bold text-white w-full"
                                                        onClick={() => editFamilyMember(item.id)}
                                                    >
                                                        Edit
                                                    </button>

                                                    <button
                                                        className="bg-secondary hover:bg-custom-blue px-4 py-2 rounded-sm font-bold text-white w-full"
                                                        onClick={() => deleteFamilyMember(item.id)}
                                                    >
                                                        Delete
                                                    </button>
                                                </div>

                                                <div className="text-black text-start mt-3 xm:mt-0">
                                                    <div className="flex items-center gap-2 py-1 w-full flex-wrap">
                                                        <BsFillTelephoneFill size={15} />
                                                        <p className="flex-1 text-sm xm:text-base font-semibold">
                                                            {formatUSPhone(item?.phoneNumber || "")}
                                                        </p>
                                                    </div>

                                                    <div className="flex items-center gap-2 py-1 w-full">
                                                        <MdEmail size={15} />
                                                        <p className="flex-1 text-left text-sm xm:text-base font-semibold break-all">
                                                            {item.emailAddress}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="min-w-full h-[120px] flex justify-center items-center">
                                <span className="text-sm">No Data Found</span>
                            </div>
                        )}

                        {totalLength > 0 && (
                            <div className="mt-6 flex flex-col xm:flex-row items-center justify-between gap-3">
                                <Pagination
                                    pageOption={[5, 10, 15, 20, 25, 50, 75, 100]}
                                    totalLength={totalLength}
                                    paginationModel={paginationModel}
                                    setPaginationModel={setPaginationModel}
                                    showEntries={showEntries}
                                    setShowEntries={setShowEntries}
                                />
                            </div>
                        )}
                    </>
                ) : (
                    <div className="min-w-full h-[300px] xm:h-[480px] flex justify-center items-center">
                        <div className="flex flex-col items-center">
                            <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-current border-r-transparent text-secondary"></div>
                            <span className="text-sm mt-2">Loading...</span>
                        </div>
                    </div>
                )}
            </section>

            {
                (isSuperAdmin || isPremiumPlan(plan)) && (
                    <>
                        <SendSms
                            open={showTheSmsPopup}
                            onClose={() => setShowTheSmsPopup(false)}
                            entityType="Ministry"
                            entityId={0}
                            entityName={`All Members`}
                        />

                        <SendEmail
                            open={showTheEmailPopup}
                            onClose={() => setShowTheEmailPopup(false)}
                            entityType="Ministry"
                            entityId={0}
                            entityName={`All Members`}
                        />
                    </>
                )
            }
        </>
    )
}

export default FamilyMembers;